export default "__VITE_ASSET__B9lDFkn8__"